import { AlertOutlineIcon } from '@atgfr8/icons';
export const TrackingBlocked = () => {
  return (
    <div class="w-full rounded-lg px-2 py-1 border-solid border-error-red border-2 bg-error-red font-roboto text-sm">
      <div class="flex items-center gap-x-2">
        <AlertOutlineIcon class="text-error-red!" />
        <div class="flex flex-col w-full">
          <div class="text-error-red font-medium">
            Tracking Blocked - No Valid Tracking Method
          </div>
          <div>
            No ELD-enabled asset was found in Trucker Tools for the entered
            truck and trailer numbers, and no driver mobile number is available.
            To enable tracking, update the Truck Number and Trailer Number OR
            enter a valid driver mobile number.
          </div>
        </div>
      </div>
    </div>
  );
};
